<template>
  <div v-if="isSelected">
    <slot />
  </div>
</template>

<script>
export default {
  name: "Tab",
  props: {
    isSelected: {
      type: Boolean
    }
  }
};
</script>
